// import { useRef, useState, useEffect } from "react";
// import { FaBars, FaTimes, FaSignOutAlt } from "react-icons/fa";
// import { FaFileAlt, FaHistory, FaUsers, FaUser, FaBook, FaTelegram } from "react-icons/fa";
// import { FaRobot } from "react-icons/fa";
// import { FaExchangeAlt } from "react-icons/fa";
// import axios from 'axios';
// import "../header/Header.css";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "../auth/Auth";
// import { SiConvertio } from "react-icons/si";
// import { IoMdFolderOpen } from "react-icons/io";
// import { IoMdDownload } from "react-icons/io";
// import { IoMdTime } from "react-icons/io";
// import { BsFillMortarboardFill } from "react-icons/bs";
// import { FaUserShield } from "react-icons/fa";
// import { FaSun, FaMoon } from "react-icons/fa"; // Додано іконки для теми

// function Header() {
//     const navRef = useRef();
//     const { user, logout } = useAuth();
//     const isLoggedIn = localStorage.getItem('refreshToken');
//     const navigate = useNavigate();
//     const location = useLocation();
//     const [username, setUsername] = useState("Користувач");
//     const [telegramLink, setTelegramLink] = useState("");
//     const [translations, setTranslations] = useState({
//         conv: '',
//         suppliers: '',
//         about: 'Про нас',
//         history: 'Історія',
//         profile: 'Профіль',
//         exit: 'Вихід'
//     });
//     const [language, setLanguage] = useState('uk-UA');
//     const [loading, setLoading] = useState(true);
//     const [generalError, setGeneralError] = useState("");
//     const [menuOpen, setMenuOpen] = useState(false);
//     const [aiToolsOpen, setAiToolsOpen] = useState(false);
//     const [casesOpen, setCasesOpen] = useState(false);
//     const [syrveInstallOpen, setSyrveInstallOpen] = useState(false); // Додано стан для Syrve Install
//     const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
//     const [userRole, setUserRole] = useState("Черговий"); // Роль за замовчуванням
//     const [theme, setTheme] = useState('white'); // Додано стан для теми
//     const [themeLoading, setThemeLoading] = useState(false); // Стан для завантаження теми

//     const isHomePage = location.pathname === '/';

//     useEffect(() => {
//         const handleResize = () => {
//             setIsMobile(window.innerWidth <= 768);
//             if (window.innerWidth > 768) {
//                 setMenuOpen(false);
//             }
//         };
        
//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);

//     // Функція для отримання ролі користувача
//     const fetchUserRole = async (userId) => {
//         try {
//             const response = await axios.get(`https://hub2.daolog.net/user-role/${userId}`);
//             if (response?.data?.role) {
//                 setUserRole(response.data.role);
//                 console.log(`Роль користувача: ${response.data.role}`);
//             }
//         } catch (error) {
//             console.error('Error fetching user role:', error);
//             // Якщо виникла помилка, встановлюємо роль за замовчуванням
//             setUserRole("Черговий");
//         }
//     };

//     // Функція для перевірки, чи є у користувача права координатора
//     const isCoordinatorMode = () => {
//         return userRole === "Координатор" || userRole === "Тімлід";
//     };


//     const isMentorMode = () => {
//         return userRole === "Координатор" || userRole === "Тімлід" || userRole === "Ментор";
//     };

//     // Функція для завантаження конфігурації теми
//     const fetchThemeConfig = async (userId) => {
//         if (!userId) return;
//         setThemeLoading(true);
//         try {
//             const response = await axios.get(`https://hub2.daolog.net/user-theme-config/${userId}`);
//             if (response?.data?.theme) {
//                 setTheme(response.data.theme);
//                 // Зберігаємо тему в localStorage для швидкого доступу
//                 localStorage.setItem('userTheme', response.data.theme);
//                 // Застосовуємо тему до body (не до хедера)
//                 document.body.className = `${response.data.theme}-theme`;
//                 console.log('Theme loaded:', response.data.theme);
//             }
//         } catch (error) {
//             console.error('Error fetching theme config:', error);
//             // За замовчуванням - світла тема
//             setTheme('white');
//             localStorage.setItem('userTheme', 'white');
//             document.body.className = 'white-theme';
//         } finally {
//             setThemeLoading(false);
//         }
//     };

//     // Функція для оновлення конфігурації теми
//     const updateThemeConfig = async (newTheme) => {
//         if (!user?.user_id) return;
        
//         const userId = user.user_id;
//         const cleanUserId = userId.toString().split(':')[0];
        
//         try {
//             setThemeLoading(true);
//             const response = await axios.put(`https://hub2.daolog.net/update-user-theme-config/${cleanUserId}`, {
//                 theme: newTheme
//             });
            
//             if (response?.data?.success) {
//                 setTheme(newTheme);
//                 localStorage.setItem('userTheme', newTheme);
//                 // Застосовуємо тему до body (не до хедера)
//                 document.body.className = `${newTheme}-theme`;
//                 console.log(`Theme updated to: ${newTheme}`);
                
//                 // Повідомляємо інші компоненти про зміну теми
//                 window.dispatchEvent(new CustomEvent('themeChanged', { detail: { theme: newTheme } }));
//             }
//         } catch (error) {
//             console.error('Error updating theme config:', error);
//             alert('Помилка при зміні теми. Спробуйте ще раз.');
//         } finally {
//             setThemeLoading(false);
//         }
//     };

//     // Функція для перемикання теми
//     const toggleTheme = () => {
//         const newTheme = theme === 'white' ? 'dark' : 'white';
//         updateThemeConfig(newTheme);
//     };

//     useEffect(() => {
//         const fetchData = async () => {
//             if (user?.user_id) {
//                 try {
//                     const userId = user.user_id;
//                     const cleanUserId = userId.toString().split(':')[0]; 
              
//                     let usernameResponse, telegramResponse, regionResponse;
                    
//                     try {
//                         usernameResponse = await axios.get(`https://hub2.daolog.net/current-user/${cleanUserId}`);
//                         if (usernameResponse?.data?.username) {
//                             setUsername(`<b>${usernameResponse.data.username}</b>`);
//                         }
//                     } catch (error) {
//                         console.error('Error fetching username:', error);
//                     }
                    
//                     try {
//                         telegramResponse = await axios.get(`https://hub2.daolog.net/user-telegram-link/${cleanUserId}`);
//                         if (telegramResponse?.data?.group_name) {
//                             setTelegramLink(telegramResponse.data.group_name);
//                         }
//                     } catch (error) {
//                         console.error('Error fetching telegram link:', error);
//                     }
                    
//                     try {
//                         regionResponse = await axios.get(`https://hub2.daolog.net/user-region/${cleanUserId}`);
//                         if (regionResponse?.data?.region) {
//                             setLanguage(regionResponse.data.region);
                           
//                             try {
//                                 const translationsResponse = await axios.get(
//                                   `https://hub2.daolog.net/translations/header/${regionResponse.data.region}`
//                                 );
//                                 if (translationsResponse?.data) {
//                                     setTranslations({
//                                         ...translations,
//                                         ...translationsResponse.data 
//                                     });
//                                 }
//                             } catch (error) {
//                                 console.error('Error fetching translations:', error);
//                             }
//                         }
//                     } catch (error) {
//                         console.error('Error fetching region:', error);
//                     }

//                     // Отримуємо роль користувача
//                     await fetchUserRole(cleanUserId);
                    
//                     // Завантажуємо конфігурацію теми
//                     await fetchThemeConfig(cleanUserId);
                    
//                 } catch (err) {
//                     console.error('Error fetching data:', err);
//                     if (err.response && err.response.status === 401) {
//                         logout();
//                         navigate('/Login');
//                     } else {
//                         setGeneralError(language === 'pl-PL' 
//                             ? 'Błąd podczas pobierania danych użytkownika' 
//                             : 'Помилка при отриманні даних користувача');
//                     }
//                 }
//             }
//             setLoading(false);
//         };
//         fetchData();
//     }, [user, navigate, logout]);

//     // Встановлюємо тему при завантаженні компонента
//     useEffect(() => {
//         const savedTheme = localStorage.getItem('userTheme') || 'white';
//         setTheme(savedTheme);
//         // Застосовуємо тему до body (не до хедера)
//         document.body.className = `${savedTheme}-theme`;
//     }, []);

//     const toggleMenu = () => {
//         setMenuOpen(!menuOpen);
//     };

//     const toggleAiTools = (e) => {
//         e.preventDefault();
//         setAiToolsOpen(!aiToolsOpen);
//         setCasesOpen(false);
//         setSyrveInstallOpen(false); // Закрити інші субменю
//     };

//     const toggleCases = (e) => {
//         e.preventDefault();
//         setCasesOpen(!casesOpen);
//         setAiToolsOpen(false);
//         setSyrveInstallOpen(false); // Закрити інші субменю
//     };

//     // Додана функція для перемикання Syrve Install
//     const toggleSyrveInstall = (e) => {
//         e.preventDefault();
//         setSyrveInstallOpen(!syrveInstallOpen);
//         setAiToolsOpen(false);
//         setCasesOpen(false);
//     };

//     const handleLogout = () => {
//         logout();
//         setUsername("Користувач"); 
//         navigate('/Login');
//     };

//     const handleLogoClick = () => {
//         navigate('/');
//     };

//     const isAiToolsPage = location.pathname === '/1' || location.pathname === '/ChatAi' || location.pathname === '/Template';
//     const isCasesPage = location.pathname === '/CasesWorking'|| location.pathname === '/CasesComplex' || location.pathname === '/CasesPending' || location.pathname === '/CasesUnprocessed';
//     // Додано перевірку для сторінок Syrve Install
//     const isSyrveInstallPage = location.pathname === '/InstallSyrve' || location.pathname === '/InstallSyrveFront';

//     if (loading) {
//         return <div>Завантаження...</div>;
//     }
  
//     if (generalError) {
//         return <div>{generalError}</div>;
//     }

//     return (
//         <>
//             <header className={`responsive-header ${menuOpen ? "menu-open" : ""}`}>
//                 <div className="header-container">
//                     <div className="logo-container" onClick={handleLogoClick} style={{cursor: 'pointer'}}>
//                         <h2>Dao hub</h2>
//                     </div>
//                     {isLoggedIn && (
//                         <>
//                             <button className="menu-toggle" onClick={toggleMenu}>
//                                 {menuOpen ? <FaTimes /> : <FaBars />}
//                             </button>
//                             <nav className={`main-nav ${menuOpen ? "active" : ""}`} ref={navRef}>
//                                 {!isHomePage ? (
//                                     <ul className="nav-links">
//                                         {}
//                                         {isCoordinatorMode() && (
//                                             <li>
//                                                 <a href="/Coordinator">
//                                                     <FaUserShield className="nav-icon" />
//                                                     <span>Режим координатора</span>
//                                                 </a>
//                                             </li>
//                                         )}
//                                              {isMentorMode() && (
//                                             <li>
//                                                 <a href="/MentorsPage">
//                                                     <FaUserShield className="nav-icon" />
//                                                     <span>Режим ментора</span>
//                                                 </a>
//                                             </li>
//                                         )}
//                                         <li>
//                                             {/* <a href="/1" onClick={menuOpen ? toggleAiTools : undefined}>
//                                                 <IoMdDownload  className="nav-icon" />
//                                                 <span>Syrve Install</span>
//                                             </a> */}
                                          
//                                             {menuOpen && (
//                                                 <ul className={`submenu ${aiToolsOpen ? 'active' : ''}`}>
//                                                      <li><a href="/ChatAi">Install Office/Chain</a></li>
//                                                      <li><a href="/Template">Install Front</a></li>
//                                                 </ul>
//                                             )}
//                                         </li>
//                                         {/* <li>
//                                             <a href="/1" onClick={menuOpen ? toggleAiTools : undefined}>
//                                                 <FaRobot className="nav-icon" />
//                                                 <span>AI Tools</span>
//                                             </a>
                                          
//                                             {menuOpen && (
//                                                 <ul className={`submenu ${aiToolsOpen ? 'active' : ''}`}>
//                                                      <li><a href="/ChatAi">AI Ментор</a></li>
//                                                      <li><a href="/Template">Шаблонізатор</a></li>
//                                                 </ul>
//                                             )}
//                                         </li> */}
//                                         {/* <li>
//                                             <a href="/CasesWorking" onClick={menuOpen ? toggleCases : undefined}>
//                                                 <IoMdFolderOpen className="nav-icon" />
//                                                 <span>Cases</span>
//                                             </a>
                                           
//                                             {menuOpen && (
//                                                 <ul className={`submenu ${casesOpen ? 'active' : ''}`}>
//                                                     <li><a href="/CasesUnprocessed">Необроблені</a></li>
//                                                     <li><a href="/CasesWorking">Робочі кейси</a></li>
//                                                     <li><a href="/CasesComplex">Складні кейси</a></li>
//                                                     <li><a href="/CasesPending">Вікладені</a></li>
//                                                 </ul>
//                                             )}
//                                         </li> */}
//                                         {/* Змінено цей пункт для Syrve Install */}
//                                         <li>
//                                         <a href="/DutyPage" onClick={menuOpen ? toggleSyrveInstall : undefined}>
//                                                 <IoMdTime className="nav-icon" />
//                                                 <span>Зміни</span>
//                                             </a>
//                                             </li>
//                                         <li>
                                       
//                                             <a href="/InstallSyrve" onClick={menuOpen ? toggleSyrveInstall : undefined}>
//                                                 <IoMdDownload  className="nav-icon" />
//                                                 <span>Syrve Install</span>
//                                             </a>
                                           
//                                             {menuOpen && (
//                                                 <ul className={`submenu ${syrveInstallOpen ? 'active' : ''}`}>
//                                                     <li><a href="/InstallSyrve">Install Office/Chain</a></li>
//                                                     <li><a href="/InstallSyrveFront">Install Front</a></li>
//                                                 </ul>
//                                             )}
//                                         </li>
                                        
//                                         <li>
//                                             <a href="/TimeTracker">
//                                                 <IoMdTime  className="nav-icon" />
//                                                 <span>Time Tracker</span>
//                                             </a>
//                                         </li>
//                                         <li>
//                                             <a href="https://kb.daolog.net/" target="_blank" rel="noopener noreferrer">
//                                                 <FaBook className="nav-icon" />
//                                                 <span>База знань</span>
//                                             </a>
//                                         </li>
                                   
                                        
//                                         {/* Кнопка зміни теми */}
//                                         <li>
//                                             <a href="#" onClick={(e) => {
//                                                 e.preventDefault();
//                                                 toggleTheme();
//                                             }} className="theme-toggle-btn">
//                                                 {theme === 'white' ? (
//                                                     <FaSun className="nav-icon theme-icon" />
//                                                 ) : (
//                                                     <FaMoon className="nav-icon theme-icon" />
//                                                 )}
//                                                 <span>{theme === 'white' ? 'Світла тема' : 'Темна тема'}</span>
//                                             </a>
//                                         </li>
                                        
//                                         <li>
//                                             <a href="#" onClick={handleLogout}>
//                                                 <FaSignOutAlt className="nav-icon" />
//                                                 <span>{translations?.exit || 'Вихід'}</span>
//                                             </a>
//                                         </li>
//                                     </ul>
//                                 ) : (
//                                     <ul className="nav-links">
//                                         {/* Режим координатора на головній сторінці */}
//                                         {isCoordinatorMode() && (
//                                             <li>
//                                                 <a href="/Coordinator">
//                                                     <FaUserShield className="nav-icon" />
//                                                     <span>Режим координатора</span>
//                                                 </a>
//                                             </li>
                                            
                                            
//                                         )}
                                        
//                                         {isMentorMode() && (
//                                             <li>
//                                                 <a href="/MentorsPage">
//                                                     <FaUserShield className="nav-icon" />
//                                                     <span>Режим ментора</span>
//                                                 </a>
//                                             </li>
                                            
                                            
//                                         )}
//                                         {/* Кнопка зміни теми на головній сторінці */}
//                                         <li>
//                                             <a href="#" onClick={(e) => {
//                                                 e.preventDefault();
//                                                 toggleTheme();
//                                             }} className="theme-toggle-btn">
//                                                 {theme === 'white' ? (
//                                                     <FaSun className="nav-icon theme-icon" />
//                                                 ) : (
//                                                     <FaMoon className="nav-icon theme-icon" />
//                                                 )}
//                                                 <span>{theme === 'white' ? 'Світла тема' : 'Темна тема'}</span>
//                                             </a>
//                                         </li>
                                        
//                                         <li>
//                                             <a href="#" onClick={handleLogout}>
//                                                 <FaSignOutAlt className="nav-icon" />
//                                                 <span>{translations?.exit || 'Вихід'}</span>
//                                             </a>
//                                         </li>
//                                     </ul>
//                                 )}
//                             </nav>
//                         </>
//                     )}
//                     {!isLoggedIn && (
//                         <nav className="main-nav">
//                             <a href="/Login" className="login-link">Login</a>
//                         </nav>
//                     )}
//                 </div>
//                 {!isMobile && !isHomePage && (
//                     <div className="user-info">
//                         <div className="user-info-content">
//                             <div className="username" dangerouslySetInnerHTML={{__html: username}}></div>
//                             <div className="user-role" style={{fontSize: '12px', color: '#666', marginTop: '5px'}}>
//                                 {/* Роль: {userRole} */}
//                             </div>
//                             {(isAiToolsPage || isCasesPage || isSyrveInstallPage) && (
//                                 <div className="sub-nav-container">
//                                     {/* {isAiToolsPage && (
//                                         <ul className="sub-nav-links">
//                                             <li><a href="/ChatAi">AI Ментор</a></li>
//                                             <li><a href="/Template">Шаблонізатор</a></li>
//                                         </ul>
//                                     )} */}
//                                     {isCasesPage && (
//                                         <ul className="sub-nav-links">
//                                             <li><a href="/CasesUnprocessed">Необроблені</a></li>
//                                             <li><a href="/CasesWorking">Робочі кейси</a></li>
//                                             <li><a href="/CasesComplex">Складні кейси</a></li>
//                                             <li><a href="/CasesPending">Вікладені</a></li>
//                                         </ul>
//                                     )}
//                                     {}
//                                     {isSyrveInstallPage && (
//                                         <ul className="sub-nav-links">
//                                             <li><a href="/InstallSyrve">Install Office/Chain</a></li>
//                                             <li><a href="/InstallSyrveFront">Install Front</a></li>
//                                         </ul>
//                                     )}
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 )}
//             </header>
//             <div className="content-spacer"></div>
//         </>
//     );
// }

// export default Header;

import { useRef, useState, useEffect } from "react";
import { FaBars, FaTimes, FaSignOutAlt } from "react-icons/fa";
import { FaFileAlt, FaHistory, FaUsers, FaUser, FaBook, FaTelegram } from "react-icons/fa";
import { FaRobot } from "react-icons/fa";
import { FaExchangeAlt } from "react-icons/fa";
import axios from 'axios';
import "../header/Header.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/Auth";
import { SiConvertio } from "react-icons/si";
import { IoMdFolderOpen } from "react-icons/io";
import { IoMdDownload } from "react-icons/io";
import { IoMdTime } from "react-icons/io";
import { BsFillMortarboardFill } from "react-icons/bs";
import { FaUserShield } from "react-icons/fa";
import { FaSun, FaMoon } from "react-icons/fa";

function Header() {
    const navRef = useRef();
    const { user, logout } = useAuth();
    const isLoggedIn = localStorage.getItem('refreshToken');
    const navigate = useNavigate();
    const location = useLocation();
    const [username, setUsername] = useState("Користувач");
    const [telegramLink, setTelegramLink] = useState("");
    const [translations, setTranslations] = useState({
        conv: '',
        suppliers: '',
        about: 'Про нас',
        history: 'Історія',
        profile: 'Профіль',
        exit: 'Вихід'
    });
    const [language, setLanguage] = useState('uk-UA');
    const [loading, setLoading] = useState(true);
    const [generalError, setGeneralError] = useState("");
    const [menuOpen, setMenuOpen] = useState(false);
    const [aiToolsOpen, setAiToolsOpen] = useState(false);
    const [casesOpen, setCasesOpen] = useState(false);
    const [syrveInstallOpen, setSyrveInstallOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [userRole, setUserRole] = useState("Черговий");
    const [theme, setTheme] = useState('white');
    const [themeLoading, setThemeLoading] = useState(false);

    const isHomePage = location.pathname === '/';

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            if (window.innerWidth > 768) {
                setMenuOpen(false);
            }
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Функція для перевірки та автоматичного виходу, якщо username = "Користувач"
    const checkAndAutoLogout = (usernameValue) => {
        // Якщо username дорівнює "Користувач" (не вдалося отримати справжнє ім'я)
        if (usernameValue === "Користувач" && isLoggedIn) {
            console.log("Виявлено проблему з авторизацією (username = Користувач). Виконується автоматичний вихід...");
            logout();
            navigate('/Login');
            return true;
        }
        return false;
    };

    // Функція для отримання ролі користувача
    const fetchUserRole = async (userId) => {
        try {
            const response = await axios.get(`https://hub2.daolog.net/user-role/${userId}`);
            if (response?.data?.role) {
                setUserRole(response.data.role);
                console.log(`Роль користувача: ${response.data.role}`);
            }
        } catch (error) {
            console.error('Error fetching user role:', error);
            setUserRole("Черговий");
        }
    };

    const isCoordinatorMode = () => {
        return userRole === "Координатор" || userRole === "Тімлід";
    };

    const isMentorMode = () => {
        return userRole === "Координатор" || userRole === "Тімлід" || userRole === "Ментор";
    };

    const fetchThemeConfig = async (userId) => {
        if (!userId) return;
        setThemeLoading(true);
        try {
            const response = await axios.get(`https://hub2.daolog.net/user-theme-config/${userId}`);
            if (response?.data?.theme) {
                setTheme(response.data.theme);
                localStorage.setItem('userTheme', response.data.theme);
                document.body.className = `${response.data.theme}-theme`;
                console.log('Theme loaded:', response.data.theme);
            }
        } catch (error) {
            console.error('Error fetching theme config:', error);
            setTheme('white');
            localStorage.setItem('userTheme', 'white');
            document.body.className = 'white-theme';
        } finally {
            setThemeLoading(false);
        }
    };

    const updateThemeConfig = async (newTheme) => {
        if (!user?.user_id) return;
        
        const userId = user.user_id;
        const cleanUserId = userId.toString().split(':')[0];
        
        try {
            setThemeLoading(true);
            const response = await axios.put(`https://hub2.daolog.net/update-user-theme-config/${cleanUserId}`, {
                theme: newTheme
            });
            
            if (response?.data?.success) {
                setTheme(newTheme);
                localStorage.setItem('userTheme', newTheme);
                document.body.className = `${newTheme}-theme`;
                console.log(`Theme updated to: ${newTheme}`);
                window.dispatchEvent(new CustomEvent('themeChanged', { detail: { theme: newTheme } }));
            }
        } catch (error) {
            console.error('Error updating theme config:', error);
            alert('Помилка при зміні теми. Спробуйте ще раз.');
        } finally {
            setThemeLoading(false);
        }
    };

    const toggleTheme = () => {
        const newTheme = theme === 'white' ? 'dark' : 'white';
        updateThemeConfig(newTheme);
    };

    useEffect(() => {
        const fetchData = async () => {
            if (user?.user_id) {
                try {
                    const userId = user.user_id;
                    const cleanUserId = userId.toString().split(':')[0]; 
              
                    let usernameResponse, telegramResponse, regionResponse;
                    let usernameValue = "Користувач";
                    
                    try {
                        usernameResponse = await axios.get(`https://hub2.daolog.net/current-user/${cleanUserId}`);
                        if (usernameResponse?.data?.username) {
                            usernameValue = `<b>${usernameResponse.data.username}</b>`;
                            setUsername(usernameValue);
                        }
                    } catch (error) {
                        console.error('Error fetching username:', error);
                        setUsername("Користувач");
                    }
                    
                    // Перевіряємо, чи потрібно виконати автоматичний вихід
                    const needLogout = checkAndAutoLogout(usernameValue);
                    if (needLogout) return;
                    
                    try {
                        telegramResponse = await axios.get(`https://hub2.daolog.net/user-telegram-link/${cleanUserId}`);
                        if (telegramResponse?.data?.group_name) {
                            setTelegramLink(telegramResponse.data.group_name);
                        }
                    } catch (error) {
                        console.error('Error fetching telegram link:', error);
                    }
                    
                    try {
                        regionResponse = await axios.get(`https://hub2.daolog.net/user-region/${cleanUserId}`);
                        if (regionResponse?.data?.region) {
                            setLanguage(regionResponse.data.region);
                           
                            try {
                                const translationsResponse = await axios.get(
                                  `https://hub2.daolog.net/translations/header/${regionResponse.data.region}`
                                );
                                if (translationsResponse?.data) {
                                    setTranslations({
                                        ...translations,
                                        ...translationsResponse.data 
                                    });
                                }
                            } catch (error) {
                                console.error('Error fetching translations:', error);
                            }
                        }
                    } catch (error) {
                        console.error('Error fetching region:', error);
                    }

                    await fetchUserRole(cleanUserId);
                    await fetchThemeConfig(cleanUserId);
                    
                } catch (err) {
                    console.error('Error fetching data:', err);
                    if (err.response && err.response.status === 401) {
                        logout();
                        navigate('/Login');
                    } else {
                        setGeneralError(language === 'pl-PL' 
                            ? 'Błąd podczas pobierania danych użytkownika' 
                            : 'Помилка при отриманні даних користувача');
                    }
                }
            }
            setLoading(false);
        };
        fetchData();
    }, [user, navigate, logout]);

    useEffect(() => {
        const savedTheme = localStorage.getItem('userTheme') || 'white';
        setTheme(savedTheme);
        document.body.className = `${savedTheme}-theme`;
    }, []);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const toggleAiTools = (e) => {
        e.preventDefault();
        setAiToolsOpen(!aiToolsOpen);
        setCasesOpen(false);
        setSyrveInstallOpen(false);
    };

    const toggleCases = (e) => {
        e.preventDefault();
        setCasesOpen(!casesOpen);
        setAiToolsOpen(false);
        setSyrveInstallOpen(false);
    };

    const toggleSyrveInstall = (e) => {
        e.preventDefault();
        setSyrveInstallOpen(!syrveInstallOpen);
        setAiToolsOpen(false);
        setCasesOpen(false);
    };

    const handleLogout = () => {
        logout();
        setUsername("Користувач"); 
        navigate('/Login');
    };

    const handleLogoClick = () => {
        navigate('/');
    };

    const isAiToolsPage = location.pathname === '/1' || location.pathname === '/ChatAi' || location.pathname === '/Template';
    const isCasesPage = location.pathname === '/CasesWorking'|| location.pathname === '/CasesComplex' || location.pathname === '/CasesPending' || location.pathname === '/CasesUnprocessed';
    const isSyrveInstallPage = location.pathname === '/InstallSyrve' || location.pathname === '/InstallSyrveFront';

    if (loading) {
        return <div>Завантаження...</div>;
    }
  
    if (generalError) {
        return <div>{generalError}</div>;
    }

    return (
        <>
            <header className={`responsive-header ${menuOpen ? "menu-open" : ""}`}>
                <div className="header-container">
                    <div className="logo-container" onClick={handleLogoClick} style={{cursor: 'pointer'}}>
                        <h2>Dao hub</h2>
                    </div>
                    {isLoggedIn && (
                        <>
                            <button className="menu-toggle" onClick={toggleMenu}>
                                {menuOpen ? <FaTimes /> : <FaBars />}
                            </button>
                            <nav className={`main-nav ${menuOpen ? "active" : ""}`} ref={navRef}>
                                {!isHomePage ? (
                                    <ul className="nav-links">
                                        {isCoordinatorMode() && (
                                            <li>
                                                <a href="/Coordinator">
                                                    <FaUserShield className="nav-icon" />
                                                    <span>Режим координатора</span>
                                                </a>
                                            </li>
                                        )}
                                        {isMentorMode() && (
                                            <li>
                                                <a href="/MentorsPage">
                                                    <FaUserShield className="nav-icon" />
                                                    <span>Режим ментора</span>
                                                </a>
                                            </li>
                                        )}
                                        <li>
                                            <a href="/DutyPage" onClick={menuOpen ? toggleSyrveInstall : undefined}>
                                                <IoMdTime className="nav-icon" />
                                                <span>Зміни</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="/InstallSyrve" onClick={menuOpen ? toggleSyrveInstall : undefined}>
                                                <IoMdDownload className="nav-icon" />
                                                <span>Syrve Install</span>
                                            </a>
                                            {menuOpen && (
                                                <ul className={`submenu ${syrveInstallOpen ? 'active' : ''}`}>
                                                    <li><a href="/InstallSyrve">Install Office/Chain</a></li>
                                                    <li><a href="/InstallSyrveFront">Install Front</a></li>
                                                </ul>
                                            )}
                                        </li>
                                        <li>
                                            <a href="/TimeTracker">
                                                <IoMdTime className="nav-icon" />
                                                <span>Time Tracker</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://kb.daolog.net/" target="_blank" rel="noopener noreferrer">
                                                <FaBook className="nav-icon" />
                                                <span>База знань</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" onClick={(e) => {
                                                e.preventDefault();
                                                toggleTheme();
                                            }} className="theme-toggle-btn">
                                                {theme === 'white' ? (
                                                    <FaSun className="nav-icon theme-icon" />
                                                ) : (
                                                    <FaMoon className="nav-icon theme-icon" />
                                                )}
                                                <span>{theme === 'white' ? 'Світла тема' : 'Темна тема'}</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" onClick={handleLogout}>
                                                <FaSignOutAlt className="nav-icon" />
                                                <span>{translations?.exit || 'Вихід'}</span>
                                            </a>
                                        </li>
                                    </ul>
                                ) : (
                                    <ul className="nav-links">
                                        {isCoordinatorMode() && (
                                            <li>
                                                <a href="/Coordinator">
                                                    <FaUserShield className="nav-icon" />
                                                    <span>Режим координатора</span>
                                                </a>
                                            </li>
                                        )}
                                        {isMentorMode() && (
                                            <li>
                                                <a href="/MentorsPage">
                                                    <FaUserShield className="nav-icon" />
                                                    <span>Режим ментора</span>
                                                </a>
                                            </li>
                                        )}
                                        <li>
                                            <a href="#" onClick={(e) => {
                                                e.preventDefault();
                                                toggleTheme();
                                            }} className="theme-toggle-btn">
                                                {theme === 'white' ? (
                                                    <FaSun className="nav-icon theme-icon" />
                                                ) : (
                                                    <FaMoon className="nav-icon theme-icon" />
                                                )}
                                                <span>{theme === 'white' ? 'Світла тема' : 'Темна тема'}</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" onClick={handleLogout}>
                                                <FaSignOutAlt className="nav-icon" />
                                                <span>{translations?.exit || 'Вихід'}</span>
                                            </a>
                                        </li>
                                    </ul>
                                )}
                            </nav>
                        </>
                    )}
                    {!isLoggedIn && (
                        <nav className="main-nav">
                            <a href="/Login" className="login-link">Login</a>
                        </nav>
                    )}
                </div>
                {!isMobile && !isHomePage && (
                    <div className="user-info">
                        <div className="user-info-content">
                            <div className="username" dangerouslySetInnerHTML={{__html: username}}></div>
                            <div className="user-role" style={{fontSize: '12px', color: '#666', marginTop: '5px'}}>
                            </div>
                            {(isAiToolsPage || isCasesPage || isSyrveInstallPage) && (
                                <div className="sub-nav-container">
                                    {isCasesPage && (
                                        <ul className="sub-nav-links">
                                            <li><a href="/CasesUnprocessed">Необроблені</a></li>
                                            <li><a href="/CasesWorking">Робочі кейси</a></li>
                                            <li><a href="/CasesComplex">Складні кейси</a></li>
                                            <li><a href="/CasesPending">Вікладені</a></li>
                                        </ul>
                                    )}
                                    {isSyrveInstallPage && (
                                        <ul className="sub-nav-links">
                                            <li><a href="/InstallSyrve">Install Office/Chain</a></li>
                                            <li><a href="/InstallSyrveFront">Install Front</a></li>
                                        </ul>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </header>
            <div className="content-spacer"></div>
        </>
    );
}

export default Header;